<template>
  <div :class="['dialog', { visible: visible }]">
    <div class="title">在售商品</div>
    <div class="closeBtn" @click="visible = false"></div>
    <div class="content">
      <div class="product-grid">
        <div v-for="item in list" :key="item.id" class="product-item">
          <div class="cover">
            <img :src="item.imgName || require('@/img/datav-tc/productImg.png')" alt="" />
          </div>
          <div class="name">{{ item.materialName }}</div>
        </div>
      </div>
      <a-pagination
        v-model="pagination.current"
        :page-size="pagination.pageSize"
        :total="pagination.total"
        show-less-items
        @change="onChange"
      />
    </div>
  </div>
</template>
<script>
import { getOnsaleProductList } from '@/api/dashboard-tc'
import to from 'await-to'
export default {
  name: 'StatsProductDialog',
  data() {
    return {
      visible: false,
      list: [],
      pagination: {
        current: 1,
        pageSize: 18,
        total: 0,
      },
    }
  },
  methods: {
    show() {
      this.visible = true
      this.pagination.current = 1
      this.initData()
    },
    close() {
      this.visible = false
    },
    async initData() {
      const [res, err] = await to(
        getOnsaleProductList({
          current: this.pagination.current,
          size: this.pagination.pageSize,
        }),
      )
      if (err) return
      if (res.code === 200 || res.code === 0) {
        this.list = res.data.list || []
        this.pagination.total = res.data.total || 0
      }
    },
    onChange(current) {
      this.pagination.current = current
      this.initData()
    },
  },
}
</script>
<style lang="scss" scoped>
.dialog {
  z-index: 99999999;
  width: 3212px !important;
  height: 1564px !important;
  background: url('~@/img/datav-tc/dialog_bg.png');
  background-size: 100% 100%;
  position: fixed;
  left: 50%;
  top: 50%;
  margin-left: -1606px;
  margin-top: -782px;
  display: none;

  .title {
    font-size: 57px;
    text-align: center;
    line-height: 107px;
    margin-bottom: 50px;
  }

  .closeBtn {
    cursor: pointer;
    width: 58px;
    height: 58px;
    position: absolute;
    right: 40px;
    top: 34px;
    background: url('~@/img/datav-tc/dialog_close_btn.png');
    background-size: 100% 100%;
  }

  .content {
    padding: 0 120px;
    height: calc(100% - 200px);

    .product-grid {
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;

      .product-item {
        width: 440px;
        height: 380px;
        margin-right: 40px;
        margin-bottom: 40px;
        padding: 20px;
        box-sizing: border-box;
        background: linear-gradient(180deg, rgba(20, 95, 163, 0.41), rgba(23, 77, 168, 0.24));
        display: flex;
        flex-direction: column;
        align-items: center;

        &:nth-of-type(6n) {
          margin-right: 0;
        }

        .cover {
          width: 280px;
          height: 280px;
          margin-bottom: 20px;
          display: flex;
          align-items: center;
          justify-content: center;

          img {
            max-width: 100%;
            max-height: 100%;
            object-fit: contain;
          }
        }

        .name {
          font-weight: normal;
          font-size: 28px;
          color: #ffffff;
          text-align: center;
          line-height: 1.4;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          width: 100%;
        }
      }
    }

    ::v-deep .ant-pagination {
      position: absolute;
      bottom: 60px;
      left: 0;
      width: 100%;
      text-align: center;
      padding-top: 20px;

      > li {
        width: 58px;
        height: 58px;
        box-sizing: border-box;
        border: 2px solid #46639a;
        font-weight: normal;
        font-size: 24px;
        line-height: 54px;
        text-align: center;
        background-color: transparent;
        margin: 0 10px;

        .ant-pagination-item-link {
          background-color: transparent;
          border: 0;
        }

        a {
          color: #46629a;
        }

        &.ant-pagination-item-active {
          background-color: #46639a;

          a {
            color: #fff;
          }
        }
      }
    }
  }

  &.visible {
    display: block;
    animation: anim-open 0.5s ease;
  }

  @keyframes anim-open {
    0% {
      transform: scale(0);
    }

    100% {
      transform: scale(1);
    }
  }
}
</style>
